module.exports = __webpack_public_path__ + "static/media/Jingle Bell Rock- Lyrics.7a32fe28.mp3";